import http from '@/utils/http';

export default {
	// 区域分组
	groupList: data => {
		return http({ url: '/api/admin/v1/areaGroup/list', data }).then(r => r);
	},
	groupCreate: data => {
		return http({ url: '/api/admin/v1/areaGroup/create', data, tip: true }).then(r => r);
	},
	groupUpdate: data => {
		return http({ url: '/api/admin/v1/areaGroup/update', data, tip: true }).then(r => r);
	},
	groupDelete: data => {
		return http({ url: '/api/admin/v1/areaGroup/delete', data, tip: true }).then(r => r);
	},
	groupToggleStatus: data => {
		return http({ url: '/api/admin/v1/areaGroup/toggleStatus', data, tip: true }).then(r => r);
	},

	// 下拉选项（不分页，仅返回 area_id/area_name/group_name）
	options: data => {
		return http({ url: '/api/admin/v1/area/options', data }).then(r => r);
	},

	// 区域
	list: data => {
		return http({ url: '/api/admin/v1/area/list', data }).then(r => r);
	},
	detail: data => {
		return http({ url: '/api/admin/v1/area/detail', data }).then(r => r);
	},
	create: data => {
		return http({ url: '/api/admin/v1/area/create', data, tip: true }).then(r => r);
	},
	update: data => {
		return http({ url: '/api/admin/v1/area/update', data, tip: true }).then(r => r);
	},
	delete: data => {
		return http({ url: '/api/admin/v1/area/delete', data, tip: true }).then(r => r);
	},
	toggleStatus: data => {
		return http({ url: '/api/admin/v1/area/toggleStatus', data, tip: true }).then(r => r);
	},
	saveFence: data => {
		return http({ url: '/api/admin/v1/area/saveFence', data, tip: true }).then(r => r);
	},
	fenceConflictCandidates: data => {
		return http({ url: '/api/admin/v1/area/fenceConflictCandidates', data }).then(r => r);
	},

	// 企业业务区域
	businessGroupedAreas: data => {
		return http({ url: '/api/admin/v1/companyArea/groupedAreas', data }).then(r => r);
	},
	businessSaveSelected: data => {
		return http({ url: '/api/admin/v1/companyArea/saveSelected', data, tip: true }).then(r => r);
	},
};
